define((require) => {
    "use strict";

    const ImprovedView = require("editor/zbone/ImprovedView");
    const KeyCode      = require("shared/services/KeyCode");
    const template     = require("components/tag_input/TagView.tpl");

    const ENTER_KEYS = [KeyCode.ENTER, KeyCode.RETURN];
    /**
     * A tag view represents a single tag among all tags.
     *
     * @class TagView
     * @author Yijie Li
     */
    return ImprovedView.extend({

        tagName: "li",

        className: "tag",

        template,

        templateHelpers() {
            return {
                isNew: !this.model.has("id")
            };
        },

        bindings() {
            return {
                ".value": this.options.propName
            };
        },

        events: {
            "click .delete": "destroy",
            "keydown .value": "_handleKeyEvents",
            "click": "_clickHandler",
            "blur .value": "_blurHandler"
        },

        _clickHandler(event) {
            event.stopPropagation();
        },

        _blurHandler() {
            if (!this.model.get(this.options.propName) && !this.model.has("id")) {
                this.destroy();
            }
        },

        // We don't allow line break in the input
        _handleKeyEvents(event) {
            if (ENTER_KEYS.indexOf(event.keyCode) !== -1) {
                event.preventDefault();
            }
        },

        destroy() {
            this.model.destroy();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/components/tag_input/TagView.js